export default __webpack_public_path__ + "static/media/about-hero-2.54de2294.png";